import { Fragment, h } from "preact";
import { TableComponent } from "../../../../components/table/styled";
import { ITableData } from "../../interfaces/table";

export const TableData = ({ columns, data, loading }: ITableData) => {
  return (
    <>
      <TableComponent
        style={{ textAlign: "center" }}
        columns={columns}
        loading={loading}
        dataSource={data}
        bordered
        size="middle"
        scroll={{ x: "max-content" }}
      />
    </>
  );
};
